import { render, staticRenderFns } from "./elect_cmp_update.vue?vue&type=template&id=3a3b9f6e"
import script from "./elect_cmp_update.vue?vue&type=script&lang=js"
export * from "./elect_cmp_update.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports